module.exports = __webpack_public_path__ + "static/stb_toast-messages-structure-3e61b543ec45f7afacf6d1606fa5a304.jpg";